import client from './client'

const sendMessage = (message) => client.post('/messages', message)

export default { sendMessage }
